import useClaimIpRewards from '@/application/write/positions/useClaimIpRewards';
import useLpClaimRewards from '@/application/write/positions/useClaimLpRewards';
import {
  ActionItem,
  ActionList,
} from '@/presentation/components/modules/ActionList';
import {
  InventoryPosition,
  LiquidityPool,
  LiquidityPosition,
  Vault,
} from 'nftx.js';

const ClaimLpRewardsItem = ({
  index,
  position,
  pool,
}: {
  index: number;
  position: LiquidityPosition;
  pool: LiquidityPool;
}) => {
  const [write, { status, error }] = useLpClaimRewards();

  const action = () => {
    write({ pool, position, userAddress: position.userAddress });
  };

  const label = `Claim ${pool.tokens[0].symbol}-${pool.tokens[1].symbol}`;

  return (
    <ActionItem
      index={index}
      label={label}
      status={status}
      error={error}
      action={action}
    />
  );
};

const ClaimIpRewardsItem = ({
  index,
  position,
  vault,
}: {
  index: number;
  position: InventoryPosition;
  vault: Pick<Vault, 'token'>;
}) => {
  const [write, { status, error }] = useClaimIpRewards();

  const label = `Claim ${vault.token.symbol}`;

  const action = () => {
    write({ positionId: position.id, vaultId: position.vaultId });
  };

  return (
    <ActionItem
      index={index}
      label={label}
      status={status}
      error={error}
      action={action}
    />
  );
};

const ClaimRewardsProcessing = ({
  liquidityPositions,
  liquidityPools,
  inventoryPositions,
  vaults,
  onCancel,
  onComplete,
}: {
  liquidityPositions: Array<LiquidityPosition>;
  inventoryPositions: Array<InventoryPosition>;
  liquidityPools: LiquidityPool[];
  vaults: Pick<Vault, 'token' | 'vaultId'>[];
  onComplete: () => void;
  onCancel: () => void;
}) => {
  const items: JSX.Element[] = [];

  [...liquidityPositions].reverse().forEach((position) => {
    const pool = liquidityPools.find((pool) => pool.id === position.poolId);
    if (!pool) {
      return;
    }

    items.push(
      <ClaimLpRewardsItem
        key={items.length}
        index={items.length}
        position={position}
        pool={pool}
      />
    );
  });

  inventoryPositions.forEach((position) => {
    const vault = vaults.find((vault) => vault.vaultId === position.vaultId);
    if (!vault) {
      return;
    }

    items.push(
      <ClaimIpRewardsItem
        key={items.length}
        index={items.length}
        position={position}
        vault={vault}
      />
    );
  });

  return (
    <ActionList
      description="Claiming Rewards"
      title="Rewards earned from NFTX vault fees and LP swap fees"
      onComplete={onComplete}
      onCancel={onCancel}
    >
      {items}
    </ActionList>
  );
};

export default ClaimRewardsProcessing;
